import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertModalCloseButton, AlertModalTitle } from "@air/primitive-alert-modal";
import pluralize from "pluralize";
export const DeleteAssetMessageModalTitle = (param)=>{
    let { onDismiss, ignoredAssetIds, removedAssetIds } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-3 flex justify-between",
        children: [
            /*#__PURE__*/ _jsx(AlertModalTitle, {
                "data-testid": "DELETE_ASSET_MESSAGE_MODAL_TITLE",
                children: ignoredAssetIds.length ? "Unable to delete ".concat(pluralize("asset", ignoredAssetIds.length, ignoredAssetIds.length > 1)) : removedAssetIds.length === 1 ? "Asset was removed from board(s) instead" : "".concat(removedAssetIds.length, " assets were removed from board(s) instead")
            }),
            /*#__PURE__*/ _jsx(AlertModalCloseButton, {
                "data-testid": "DELETE_ASSET_MESSAGE_MODAL_CLOSE",
                className: "shrink-0",
                onClick: onDismiss
            })
        ]
    });
};
